import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { hero, whatsappLink } from "@/content";
import { HeroDashboard } from "./HeroDashboard";

const fade = (d) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay: d, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => {
  const base = hero.titulo.replace(hero.destaque, "");
  return (
    <section id="topo" data-testid="hero-section" className="relative overflow-hidden pb-16 pt-32 sm:pb-28 sm:pt-36 lg:pb-40 lg:pt-44">
      <div className="grid-bg absolute inset-0" />
      <div className="absolute -top-40 right-0 h-[520px] w-[520px] rounded-full bg-cyan-500/10 blur-[120px]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 sm:gap-20 lg:grid-cols-[1.05fr_1fr] lg:px-8">
        <div>
          <motion.span {...fade(0)} data-testid="hero-badge"
            className="inline-flex items-center gap-2 rounded-full border border-cyan-300/20 bg-cyan-300/5 px-4 py-1.5 text-xs text-cyan-200">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-300 shadow-[0_0_8px_#67e8f9]" />
            {hero.selo}
          </motion.span>
          <motion.h1 {...fade(0.1)} data-testid="hero-title"
            className="font-display mt-8 text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl xl:text-7xl">
            {base}
            <span className="text-gradient">{hero.destaque}</span>
          </motion.h1>
          <motion.p {...fade(0.2)} data-testid="hero-subtitle"
            className="mt-6 max-w-xl text-base leading-relaxed text-slate-200 sm:mt-8 md:text-lg">
            {hero.subtitulo}
          </motion.p>
          <motion.div {...fade(0.3)} className="mt-10 flex flex-col gap-3 sm:mt-12 sm:flex-row sm:gap-4">
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="hero-primary-btn" className="btn-primary group">
              {hero.botaoPrimario}
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a href="#solucoes" data-testid="hero-secondary-btn" className="btn-ghost">
              {hero.botaoSecundario}
            </a>
          </motion.div>
          <motion.p {...fade(0.4)} data-testid="hero-service-area" className="mt-8 flex items-start gap-2 text-sm text-slate-300 sm:mt-10">
            <MapPin size={16} className="mt-0.5 shrink-0 text-cyan-300" />
            {hero.atendimento}
          </motion.p>
        </div>
        <HeroDashboard />
      </div>
    </section>
  );
};
